module.exports = __webpack_public_path__ + "media/frontend/svg/logo4-ad499938a2daf0a5d2b8159e31c13a5b.svg";